import React from "react";
import OffersListingBreadCrumb from "../../Components/Offer/OffersListing/OffersListingBreadCrumb";
import OffersListings from "../../Components/Offer/OffersListing/OffersListings";

export default function OffersListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <OffersListingBreadCrumb />
        <OffersListings />
      </div>
    </React.Fragment>
  );
}
